import React, { useState } from 'react'
import { isNil } from 'lodash'
import { Button, Grid, IconButton } from '@material-ui/core'
import { Clear } from '@material-ui/icons'
import { DefaultSelectOption, SelectInput } from '@crystalservice/crystals-ui/lib/components/inputs/select-input/select-input'
import { NOT_SELECTED_VALUE } from '../registration-form'
import { AnimalType } from './utils'

const styles = require('./../registration-page.module.scss')

interface AnimalSelectionProps {
    id: string
    options:  DefaultSelectOption[]
    required: boolean
    value: string
    onValueChange: (value: string, id: string) => void
}

export const AnimalSelection: React.FC<AnimalSelectionProps> = ({
    id,
    required,
    options,
    value,
    onValueChange,
}) => {
    const [animalsExist, setAnimalsExist] = useState<string>()
    const [animalsList, setAnimalsList] = useState<string[]>()

    const onDelete = (index: number): void => {
        const newAnimalsList: string[] = [...animalsList]
        newAnimalsList.splice(index, 1)

        const newAnimalsValues: string[] = newAnimalsList?.length > 0 ? newAnimalsList : null

        setAnimalsList(newAnimalsValues)
        onValueChange(newAnimalsList?.length > 0 ? newAnimalsList.join(',') : AnimalType.Any, id)
    }

    const onAdd = (): void => {
        if (animalsList) {
            setAnimalsList((prev) => {
                return [
                    ...prev,
                    AnimalType.Other
                ]
            })

            onValueChange([...value.split(','), AnimalType.Other].join(','), id)
        } else {
            setAnimalsList([AnimalType.Other])
            onValueChange(AnimalType.Other, id)
        }
    }

    return (
        <Grid container direction="column" spacing={2}>
            <Grid item>
                <SelectInput
                    id={`registrationField-${id}-isExist`}
                    className={styles.select}
                    required={required}
                    value={animalsExist || NOT_SELECTED_VALUE}
                    options={[
                        {
                            value: NOT_SELECTED_VALUE,
                            label: 'Не заполнено'
                        },
                        {
                            value: 'true',
                            label: 'Есть'
                        },
                        {
                            value: 'false',
                            label: 'Нет'
                        },
                    ]}
                    onSelect={opt => {
                        setAnimalsExist(opt.value)

                        if (opt.value === NOT_SELECTED_VALUE) {
                            onValueChange(null, id)
                            setAnimalsList(null)
                        }

                        if (opt.value === 'true') {
                            onValueChange(AnimalType.Any, id)
                        }

                        if (opt.value === 'false') {
                            onValueChange(AnimalType.None, id)
                            setAnimalsList(null)
                        }
                    }}
                />
            </Grid>
            <Grid item>
                {animalsList?.map((animal: string, index: number) => (
                    <Grid
                        key={`${animal}-${index}`}
                        id="animalContainer"
                        container
                        item
                        spacing={4}
                        xs={12}
                    >
                        <Grid item xs={10}>
                            <SelectInput
                                id={`registrationField-${id}`}
                                className={styles.select}
                                required={required}
                                value={animal}
                                options={options}
                                onSelect={option => {
                                    const newAnimalsList = animalsList
                                    newAnimalsList.splice(index, 1, option.value)
                                    setAnimalsList(newAnimalsList)
                                    onValueChange(newAnimalsList.join(','), id)
                                }}
                            />
                        </Grid>
                        <Grid container item justify="flex-end" xs={2}>
                            <IconButton onClick={() => onDelete(index)}>
                                <Clear color="primary" />
                            </IconButton>
                        </Grid>
                    </Grid>
                ))}
            </Grid>
            {(!isNil(value) && !(value === AnimalType.None)) && (
                <Grid item>
                    <Button
                        color="primary"
                        className="addAnimalButton"
                        onClick={onAdd}
                    >
                        Добавить питомца
                    </Button>
                </Grid>
            )}

        </Grid>
    )
}
